/** The opponent strength label on VS (game-design §2.2). Bots always count as an even match. */
import { opponentBand, PROGRESSION } from '@caged/shared';
import { useTranslation } from 'react-i18next';
import { formatDecimal } from '../format';
import s from './StrengthChip.module.css';

export function StrengthChip({ ratingDiff = 0, className }: { ratingDiff?: number; className?: string }) {
  const { t } = useTranslation();
  const band = opponentBand(ratingDiff);
  const dots = PROGRESSION.opponentBands.indexOf(band) + 1;
  const tone = band.label === 'easy' ? s.easy : band.label === 'tough' ? s.tough : s.even;
  return (
    <div className={[s.chip, tone, className ?? ''].join(' ')}>
      <span className={s.dots} aria-hidden="true">
        {PROGRESSION.opponentBands.map((b, i) => (
          <span key={b.maxDiff} className={[s.dot, i < dots ? s.dotOn : ''].join(' ')} />
        ))}
      </span>
      <span className={s.label}>{t(`screens.vs.strength.${band.label}`)}</span>
      {band.multiplier !== 1 && <span className={s.mult}>{t('screens.vs.strength.mult', { mult: formatDecimal(band.multiplier) })}</span>}
    </div>
  );
}
